module.exports = __webpack_public_path__ + "static/img/modal-complete.422e83dd.png";